import React from 'react'

import clsx from 'clsx'

import Button from 'components/Button'
import Typography from 'components/Typography'

import classes from './CtaButton.module.scss'

const TEXT_VARIANTS = {
  small: 'button-sm',
  medium: 'button-md',
  large: 'button-lg',
}

/** @type {import("./types").default} */
const CtaButton = ({
  className,
  disabled,
  fullWidth,
  href,
  label,
  children,
  onClick,
  rel,
  secondary,
  self,
  shortLabel,
  size = 'medium',
  variant = 'contained',
  ...moreProps
}) => {
  return (
    <Button
      className={clsx('CtaButton', classes.button, className)}
      color={secondary ? 'secondary' : 'primary'}
      disabled={disabled}
      fullWidth={fullWidth}
      href={href}
      onClick={onClick}
      rel={rel}
      target={!self && href ? '_blank' : null}
      variant={variant}
      size={size}
      {...moreProps}
    >
      <Typography
        className={clsx(classes.label, { [classes.hideLabel]: shortLabel })}
        component="span"
        variant={TEXT_VARIANTS[size]}
      >
        {label || children}
      </Typography>

      {shortLabel && (
        <Typography className={classes.shortLabel} component="span" variant={TEXT_VARIANTS[size]}>
          {shortLabel}
        </Typography>
      )}
    </Button>
  )
}

export default CtaButton
